<template>
    <div class="md-group">
        <md-button @click="$emit('input',sendValue)" class="md-sm md-toggle"
                   :disabled="disabled"
                   :class="trueClass">
            <md-icon>check_circle</md-icon>
            Да
        </md-button>
        <md-button @click="$emit('input',sendValue)" class="md-sm md-toggle"
                   :disabled="disabled"
                   :class="falseClass">
            <md-icon>remove_circle</md-icon>
            Нет
        </md-button>
    </div>
</template>

<script>
  export default {
    name: "toggleWings",
    props:{
      value:{default:0},
      mdClass:{default:'md-primary'},
      trueValue:{default: 1},
      falseValue:{default: 0},
      disabled:{default: false},
    },
    computed:{
      trueClass(){
        return this.value==this.trueValue?this.mdClass:'md-simple'
      },
      falseClass(){
        return this.value==this.falseValue?this.mdClass:'md-simple'
      },
      sendValue(){
        if (this.value == this.trueValue){
          return this.falseValue
        }
        return this.trueValue
      }
    }
  }
</script>

<style scoped>

</style>